import { render, staticRenderFns } from "./FormFormat.vue?vue&type=template&id=55e9ddbf&scoped=true"
import script from "./FormFormat.vue?vue&type=script&lang=js"
export * from "./FormFormat.vue?vue&type=script&lang=js"
import style0 from "./FormFormat.vue?vue&type=style&index=0&id=55e9ddbf&prod&lang=scss"
import style1 from "./FormFormat.vue?vue&type=style&index=1&id=55e9ddbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e9ddbf",
  null
  
)

export default component.exports